<template>
    <div>
        <!-- 版权存证 -->
        <div class="cz_box" style="">
            <img src='../../images/czzsnew.gif' class="cz_zhengshu"/>
            <div class="cz_right">
                <p class="cz_right_tit">版权存证</p>
                <p class="cz_right_t">作品的“出生证”，创作完成第一时间存证可有效证明作品的诞生时间和权属</p>
                <ul class="cz_right_list">
                    <li>
                        <img src='../../images/gxbj.png'/>
                        <span>高效便捷</span>
                        <span>创作即确权</span>
                    </li>
                    <li>
                        <img src='../../images/sfrk.png'/>
                        <span>司法认可</span>
                        <span>打造完整证据链<br/>维权无忧</span>
                    </li>
                    <li>
                        <img src='../../images/gxjb.png'/>
                        <span>高性价比</span>
                        <span>高品质服务，行业低价</span>
                    </li>
                    <li>
                        <img src='../../images/qkljs.png'/>
                        <span>区块链技术</span>
                        <span>直通互联网法院<br/>证据不被篡改</span>
                    </li>
                </ul>
                <div class="cz_right_btn">
                    <a @click="lijiCz" class="yellow">
                        立即存证
                        <span></span>
                        <!-- <img src='../../images/go.png'/> -->
                    </a>
                    <a style="margin-left:24px" @click="lookCzDetail" class="normal">
                        查看详情
                        <span></span>
                        <!-- <img src='../../images/go.png'/> -->
                    </a>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    

    export default {
        metaInfo: {
            title: '版权登记|版权保护-版权服务专家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权登记,版权保护,版权登记查询,版权保护中心,版权保护服务,版权登记服务,版权家'
            },{
                name: 'Description',
                content: '版权家是专业提供版权登记查询，版权保护申请；我们作为版权保护服务专家，为版权人提供极致的版权登记咨询、版权交易、版权监测、版权维权等服务体验。'
            }]
        },
        name:'indexthree',
        components:{
            
        },
        data(){
            return {
               
            }
        },

        methods:{
            lijiCz(){
                window.open('/apply-cert', '_blank')
            },
            lookCzDetail(){
                this.$router.push({path: '/cunzheng.html'})
            },
        }

    }
</script>

<style scoped lang="less">
//版权存证
    .cz_box{
        display: flex;
        width: 1200px;
        margin: 0px auto 130px;
        .cz_zhengshu{
            width: 540px;
            height: 390px;
            display: block;
            margin: 103px 100px 0 21px;
        }
        .dci_zhengshu{
             width:540px;
            height:390px;
            display: block;
                margin-top: 97px;
            // margin: 0 115px 0 47px;
        }
        .cz_right{
            flex:1;
            margin-top: 128px;
            .cz_right_tit{
                font-size: 32px;
                font-weight: bold;
                font-family:SourceHanSansCN;
                color: #333333;
                line-height: 47px;
                margin:0px 0 16px; 
            }
            .cz_right_t{
                font-size: 16px;
                font-weight: bold;
                font-family:SourceHanSansCN;
                color: #333333;
                line-height: 27px;
            }
            .cz_right_list{
                display: flex;
                margin-top:40px;
                margin-bottom:56px;
                li{
                    // flex:1;
                    // width: 130px;
                    width:84px;
                    margin-right:77px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    img{
                        width:46px;
                        height:46px;
                        display: block;
                        // margin: 0 38px;
                        margin: 0 auto;
                    }
                    span:nth-of-type(1){
                        font-size: 16px;
                        font-weight: 500;
                        font-family:SourceHanSansCN;
                        color: #333333;
                        line-height: 27px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 5px 0 3px;
                        // width: 130px;
                        text-align: center;
                    }
                    span:nth-of-type(2){
                        font-size: 12px;
                        color: #555555;
                        line-height: 18px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        // width: 130px;
                        text-align: center;
                    }
                }
            }
            .dci_right_btn{
                .yellow{
                    font-size: 14px;
                    color: #F5F5F5;
                    line-height: 40px;
                    width: 154px;
                    height: 40px;
                    border-radius: 20px;
                    display: inline-block;
                    cursor: pointer;
                    position: relative;
                    padding-left: 38px;
                    background: #FBDA5D;
                    border: 1px solid #FBDA5D;
                    color: #333333;
                    i{
                        margin-left: 6px;
                        width: 14px;
                        height: 14px;
                        display:inline-block;
                        position: absolute;
                        top: 13px;
                        background: url("../../images/goHover.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    &:hover{
                        box-shadow: 0px 4px 8px 0px rgba(255, 216, 0, 0.6);
                    }
                }
                // a{
                //     font-size: 14px;
                //     color: #F5F5F5;
                //     line-height: 40px;
                //     width: 154px;
                //     height: 40px;
                //     border-radius: 20px;
                //     border: 1px solid #E5E5E5;
                //     display: inline-block;
                //     // text-align: center;
                //     // display: flex;
                //     // justify-content: center;
                //     // align-items: center;
                //     cursor: pointer;
                //     position: relative;
                //     padding-left: 38px;
                //     i{
                //         margin-left: 6px;
                //         width: 14px;
                //         height: 14px;
                //         display:inline-block;
                //         position: absolute;
                //         top: 13px;
                //         background: url("../../images/dci_go.png") no-repeat;
                //         background-size: 100% 100%;
                //     }
                //     &:hover{
                //         background: #FBDA5D;
                //         border: 1px solid #FBDA5D;
                //         color: #333333;
                //         i{
                //             margin-left: 6px;
                //             width: 14px;
                //             height: 14px;
                //             display:inline-block;
                //             position: absolute;
                //             top: 13px;
                //             background: url("./images/goHover.png") no-repeat;
                //             background-size: 100% 100%;
                //         }
                //     }
                // }
            }
            .cz_right_btn{
                .yellow{
                    cursor: pointer;
                    font-size: 14px;
                    line-height: 40px;
                    width: 154px;
                    height: 40px;
                    border-radius: 20px;
                    border: 1px solid #E5E5E5;
                    display: inline-block;
                    position: relative;
                    padding-left: 38px;
                    background: #FBDA5D;
                    border: 1px solid #FBDA5D;
                    color: #333333;
                    // text-align: center;
                    span{
                        margin-left: 6px;
                        width: 14px;
                        height: 14px;
                        background: url("../../images/goHover.png") no-repeat;
                        background-size: 100% 100%;
                        display: inline-block;
                        position: absolute;
                        top: 13px;
                    }
                    &:hover{
                        box-shadow: 0px 4px 8px 0px rgba(255, 216, 0, 0.6);
                    }
                }
                .normal{
                    cursor: pointer;
                    font-size: 14px;
                    color: #666666;
                    line-height: 40px;
                    width: 154px;
                    height: 40px;
                    border-radius: 20px;
                    border: 1px solid #E5E5E5;
                    display: inline-block;
                    position: relative;
                    padding-left: 38px;
                    // text-align: center;
                    span{
                        margin-left: 6px;
                        width: 14px;
                        height: 14px;
                        background: url("../../images/go.png") no-repeat;
                        background-size: 100% 100%;
                        display: inline-block;
                        position: absolute;
                        top: 13px;
                    }
                    &:hover{
                        background: #FBDA5D;
                        border: 1px solid #FBDA5D;
                        color: #333333;
                        box-shadow: 0px 4px 8px 0px rgba(255, 216, 0, 0.6);
                        span{
                            margin-left: 6px;
                            width: 14px;
                            height: 14px;
                            background: url("../../images/goHover.png") no-repeat;
                            background-size: 100% 100%;
                            display: inline-block;
                            position: absolute;
                            top: 13px;
                        }
                    }
                }
            }
        }
    }
    ul{
        li{
            list-style: none;
        }
    }
</style>